import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Badge from '@material-ui/core/Badge';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = {
  drawerTitle: {
    padding: 30
  },
  drawerList: {
    padding: 5
  },
  drawerPaper: {
    width: 300
  },
  panelDetails: {
    padding: 5,
    display: 'block'
  },
  termsButton: {
    padding: '6px 16px',
    width: '100%',
    height: '100%',
    fontSize: '1em',
    justifyContent: 'flex-start'
  },
  btHide: {
    background: 'none !important',
    color: '#fff'
  }
};

const enhancer = compose(
  withState('open', 'setOpen', false),
  withState('code', 'setCode', false),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);
const MenuDrawer = enhancer(
  ({ classes, handleRedirect, account, open, setOpen, code, setCode }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isDepositManageSelf =
      typeof account !== 'undefined' && account.depositManage === 'SELF';
    const isDepositManageNonSelf =
      typeof account !== 'undefined' && account.depositManage === 'NONSELF';
    const readFlag = account && account.manageNoticeRead;
    const isCreateChildFoodShop =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      (account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0);
    console.log(isCreateChildFoodShop);
    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleOpen = () => {
      const csvCode = '9981';
      const automaticStatistics = '3309';
      const relationCode = '8864';
      const secretMenu = '6636';
      const generateCode = '7749';
      const menuCode = '5535';
      const downloadReport = '4416';
      if (code === csvCode) {
        handleRedirect('/csv-shop');
      }
      if (code === automaticStatistics) {
        handleRedirect('/automatic-statistics');
      }
      if (code === relationCode) {
        handleRedirect('/relation-shop');
      }
      if (code === secretMenu) {
        handleRedirect('/create_secret_menu');
      }
      if (code === generateCode) {
        handleRedirect('/generate-code');
      }
      if (code === menuCode) {
        handleRedirect('/csv-menu');
      }
      if (code === downloadReport) {
        handleRedirect('/download-report');
      }
      setOpen(false);
    };

    const handleClose = () => {
      setOpen(false);
    };
    return (
      <div className={classes.drawerPaper}>
        <div className={classes.drawerTitle}>
          <Typography variant="h6" color="textSecondary">
            GOCHIプラットフォーム管理システム
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Ver 1.18.0
          </Typography>
        </div>
        <Divider />

        {(isGroup || isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/groups');
              }}
            >
              <ListItemText>グループ情報管理</ListItemText>
            </ListItem>
          </List>
        )}

        {(isShop || isGroup || isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/shops');
              }}
            >
              <ListItemText>店舗情報管理</ListItemText>
            </ListItem>
          </List>
        )}

        {(isShop || isGroup || isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/list_budget');
              }}
            >
              <ListItemText>グループ入金管理</ListItemText>
            </ListItem>
          </List>
        )}

        {(isShop || isGroup || isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/list_supply_gochi');
              }}
            >
              <ListItemText>グループごち発行一覧</ListItemText>
            </ListItem>
          </List>
        )}

        {(isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/summary_report_secretariat');
              }}
            >
              <ListItemText>サマリーレポート</ListItemText>
            </ListItem>
          </List>
        )}
        {isGroup && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/summary_report_group');
              }}
            >
              <ListItemText>サマリーレポート</ListItemText>
            </ListItem>
          </List>
        )}
        {isShop && (
          <List className={classes.drawerList}>
            <ListItem
              button
              disabled
              onClick={() => {
                handleRedirect('/summary_report');
              }}
            >
              <ListItemText>サマリーレポート</ListItemText>
            </ListItem>
          </List>
        )}

        {(isShop || isGroup || isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/gochi_menus');
              }}
            >
              <ListItemText>メニュー情報管理</ListItemText>
            </ListItem>
          </List>
        )}

        {(isShop || isGroup || isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/gochi_kid_menus');
              }}
            >
              <ListItemText>こどもごちめしメニュー管理</ListItemText>
            </ListItem>
          </List>
        )}
        {isSecretariat && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/gochi_kid_receipt');
              }}
            >
              <Badge color="secondary" variant="dot" invisible={readFlag}>
                <ListItemText>こどもごちめし レシート利用履歴</ListItemText>
              </Badge>
            </ListItem>
          </List>
        )}

        {isSecretariat && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
            >
              <Typography className={classes.heading}>イベント管理</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.panelDetails}>
              <List className={classes.drawerList}>
                <ListItem
                  button
                  onClick={() => {
                    handleRedirect('/gochi_menus_event');
                  }}
                >
                  <ListItemText>イベントメニューの自動挿入</ListItemText>
                </ListItem>
              </List>
              <List className={classes.drawerList}>
                <ListItem
                  button
                  onClick={() => {
                    handleRedirect('/gochi_event_setting');
                  }}
                >
                  <ListItemText>イベント設定</ListItemText>
                </ListItem>
              </List>
            </AccordionDetails>
          </Accordion>
        )}

        {(isSecretariat || isDeveloper || isCreateChildFoodShop) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/gochi_child_food_list');
              }}
            >
              <ListItemText>こども食堂メニュー</ListItemText>
            </ListItem>
          </List>
        )}

        {(isShop || isGroup || isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/gochis');
              }}
            >
              <ListItemText>ごち検索</ListItemText>
            </ListItem>
          </List>
        )}

        {(isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/change_ticket_gochi');
              }}
            >
              <ListItemText>ごちデータの編集</ListItemText>
            </ListItem>
          </List>
        )}

        {(isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/list_booking');
              }}
            >
              <ListItemText>お客様からの連絡</ListItemText>
            </ListItem>
          </List>
        )}

        {isSecretariat && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/giftcard');
              }}
            >
              <ListItemText>ギフトカード設定</ListItemText>
            </ListItem>
          </List>
        )}

        {/* {(isShop || isGroup || isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/deposits');
              }}
            >
              <ListItemText>入金管理（Stripeのみ）</ListItemText>
            </ListItem>
          </List>
        )} */}

        {(isShop || isSecretariat || isDeveloper) && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography className={classes.heading}>開店処理</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.panelDetails}>
              {(isShop || isSecretariat || isDeveloper) && (
                <List className={classes.drawerList}>
                  <ListItem
                    button
                    onClick={() => {
                      handleRedirect('/identities');
                    }}
                  >
                    <ListItemText>本人確認書類登録</ListItemText>
                  </ListItem>
                </List>
              )}
              {(isShop || isDeveloper) && (
                <List className={classes.drawerList}>
                  <ListItem
                    button
                    onClick={() => {
                      handleRedirect('/deposit_register');
                    }}
                  >
                    <ListItemText>入金処理</ListItemText>
                  </ListItem>
                </List>
              )}
              {(isSecretariat || isDeveloper) && (
                <List className={classes.drawerList}>
                  <ListItem
                    button
                    onClick={() => {
                      handleRedirect('/group_identities');
                    }}
                  >
                    <ListItemText>グループ本人確認書類登録</ListItemText>
                  </ListItem>
                </List>
              )}

              {isShop && (
                <List className={classes.drawerList}>
                  <ListItem
                    button
                    onClick={() => {
                      handleRedirect('/release');
                    }}
                  >
                    <ListItemText>開店処理</ListItemText>
                  </ListItem>
                </List>
              )}
              {(isSecretariat || isDeveloper) && (
                <List className={classes.drawerList}>
                  <ListItem
                    button
                    onClick={() => {
                      handleRedirect('/releases');
                    }}
                  >
                    <ListItemText>店舗状況検索</ListItemText>
                  </ListItem>
                </List>
              )}
            </AccordionDetails>
          </Accordion>
        )}

        {(isShop || isGroup || isSecretariat || isDeveloper) && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
            >
              <Typography className={classes.heading}>その他</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.panelDetails}>
              {isShop && (
                <List className={classes.drawerList}>
                  <ListItem
                    button
                    onClick={() => {
                      handleRedirect('/qr_issue');
                    }}
                  >
                    <ListItemText>QRコード発行</ListItemText>
                  </ListItem>
                </List>
              )}

              {((isShop && isDepositManageSelf) ||
                isSecretariat ||
                isDeveloper) && (
                <List className={classes.drawerList}>
                  <ListItem
                    button
                    onClick={() => {
                      handleRedirect('/register_stripe');
                    }}
                  >
                    <ListItemText>自社で入金管理（オプション）</ListItemText>
                  </ListItem>
                </List>
              )}
              {isGroup && (
                <List className={classes.drawerList}>
                  <ListItem
                    button
                    onClick={() => {
                      handleRedirect('/group_register_stripe');
                    }}
                  >
                    <ListItemText>自社で入金管理（オプション）</ListItemText>
                  </ListItem>
                </List>
              )}
              {isShop && isDepositManageNonSelf && (
                <List className={classes.drawerList}>
                  <ListItem button disabled>
                    <ListItemText>自社で入金管理（オプション）</ListItemText>
                  </ListItem>
                </List>
              )}
              {(isShop || isGroup || isSecretariat || isDeveloper) && (
                <List className={classes.drawerList}>
                  <Button
                    target="_blank"
                    href="https://gochimeshi.com/policy/owner-terms/"
                    className={classes.termsButton}
                  >
                    加盟店規約
                  </Button>
                </List>
              )}
            </AccordionDetails>
          </Accordion>
        )}

        {/* {(isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/pre_shops');
              }}
            >
              <ListItemText>仮店舗検索</ListItemText>
            </ListItem>
          </List>
        )} */}

        {(isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/users');
              }}
            >
              <ListItemText>ユーザ検索</ListItemText>
            </ListItem>
          </List>
        )}

        {isSecretariat && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/user_batch_registration');
              }}
            >
              <Badge color="secondary" variant="dot" invisible={readFlag}>
                <ListItemText>ユーザ一括登録</ListItemText>
              </Badge>
            </ListItem>
          </List>
        )}

        {isSecretariat && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/identity_user_kid');
              }}
            >
              <Badge color="secondary" variant="dot" invisible={readFlag}>
                <ListItemText>こどもごちめし対象者管理</ListItemText>
              </Badge>
            </ListItem>
          </List>
        )}

        {isSecretariat && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/admin_use_gochi_kid');
              }}
            >
              <Badge color="secondary" variant="dot" invisible={readFlag}>
                <ListItemText>こどもごちめし利用</ListItemText>
              </Badge>
            </ListItem>
          </List>
        )}

        {isSecretariat && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/unused_gochi_kid');
              }}
            >
              <Badge color="secondary" variant="dot" invisible={readFlag}>
                <ListItemText>こどもごちめし利用履歴編集</ListItemText>
              </Badge>
            </ListItem>
          </List>
        )}

        {(isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/charge_event');
              }}
            >
              <ListItemText>ストライプ決済イベント管理</ListItemText>
            </ListItem>
          </List>
        )}

        {(isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              disabled
              onClick={() => {
                handleRedirect('/messages');
              }}
            >
              <ListItemText>メッセージ検索</ListItemText>
            </ListItem>
          </List>
        )}

        {(isShop || isGroup || isSecretariat || isDeveloper) && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/manage_notices');
              }}
            >
              <Badge color="secondary" variant="dot" invisible={readFlag}>
                <ListItemText>運営からのお知らせ</ListItemText>
              </Badge>
            </ListItem>
          </List>
        )}
        {isSecretariat && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/gochis_import_file');
              }}
            >
              <Badge color="secondary" variant="dot" invisible={readFlag}>
                <ListItemText>ごちファイルアップロード</ListItemText>
              </Badge>
            </ListItem>
          </List>
        )}
        {isSecretariat && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/shop_batch_registration');
              }}
            >
              <Badge color="secondary" variant="dot" invisible={readFlag}>
                <ListItemText>店舗一括登録</ListItemText>
              </Badge>
            </ListItem>
          </List>
        )}
        {isSecretariat && (
          <List className={classes.drawerList}>
            <ListItem
              button
              onClick={() => {
                handleRedirect('/gochi_charge_batch_registration');
              }}
            >
              <Badge color="secondary" variant="dot" invisible={readFlag}>
                <ListItemText>一括チャージ（地域通貨チケット）</ListItemText>
              </Badge>
            </ListItem>
          </List>
        )}
        {isSecretariat && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
            >
              <Typography className={classes.heading}>
                社食ごちめしシステム管理
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.panelDetails}>
              <List className={classes.drawerList}>
                <ListItem
                  button
                  onClick={() => {
                    handleRedirect('/shashoku_budgets');
                  }}
                >
                  <Badge color="secondary" variant="dot" invisible={readFlag}>
                    <ListItemText>社食ごちめし入金管理</ListItemText>
                  </Badge>
                </ListItem>
              </List>
              <List className={classes.drawerList}>
                <ListItem
                  button
                  onClick={() => {
                    handleRedirect('/shashoku_tickets');
                  }}
                >
                  <Badge color="secondary" variant="dot" invisible={readFlag}>
                    <ListItemText>社食ごちめしのチケット編集</ListItemText>
                  </Badge>
                </ListItem>
              </List>
              <List className={classes.drawerList}>
                <ListItem
                  button
                  onClick={() => {
                    handleRedirect('/shashoku_tickets_used_by_admin');
                  }}
                >
                  <Badge color="secondary" variant="dot" invisible={readFlag}>
                    <ListItemText>
                      社食ごちめし使用済へのデータ修正
                    </ListItemText>
                  </Badge>
                </ListItem>
              </List>
              <List className={classes.drawerList}>
                <ListItem
                  button
                  onClick={() => {
                    handleRedirect('/shashoku_refund_extra_pay');
                  }}
                >
                  <Badge color="secondary" variant="dot" invisible={readFlag}>
                    <ListItemText>社食ごちめしのチケット返金</ListItemText>
                  </Badge>
                </ListItem>
              </List>
              <List className={classes.drawerList}>
                <ListItem
                  button
                  onClick={() => {
                    handleRedirect('/shashoku_admin_send_message_to_user');
                  }}
                >
                  <Badge color="secondary" variant="dot" invisible={readFlag}>
                    <ListItemText>社食ごちめしのお知らせ</ListItemText>
                  </Badge>
                </ListItem>
              </List>
            </AccordionDetails>
          </Accordion>
        )}
        {isSecretariat && (
          <div>
            <Button
              className={classes.btHide}
              onClick={() => {
                handleClickOpen();
              }}
            >
              csv
            </Button>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">Code</DialogTitle>
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  id="code"
                  label="Code open"
                  type="text"
                  fullWidth
                  onChange={e => {
                    setCode(e.target.value);
                  }}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleOpen} color="primary">
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        )}
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(MenuDrawer));
